<template>
  <Breadcrumbs title="" main="วิธีการใช้งานระบบ" />

  <main class="admin-guide container-fluid">
    <section class="admin-guide__header">
      <div>
        <p class="admin-guide__eyebrow">RUNRACE ADMIN</p>
        <h1>วิธีการใช้งานระบบ</h1>
        <p class="admin-guide__description">
          คู่มือการเข้าสู่ระบบและดูรายงานผู้สมัครสำหรับผู้ดูแลระบบ
        </p>
      </div>
      <span class="admin-guide__count">4 ขั้นตอน</span>
    </section>

    <section class="admin-guide__steps" aria-label="ขั้นตอนการใช้งานระบบ">
      <article v-for="(image, index) in instructionImages" :key="image" class="admin-guide__step">
        <div class="admin-guide__step-label">
          <span>{{ String(index + 1).padStart(2, '0') }}</span>
          <h2>{{ stepTitles[index] }}</h2>
        </div>
        <img
          :src="image"
          :alt="`วิธีการใช้งานระบบ ขั้นตอนที่ ${index + 1}`"
          class="admin-guide__image"
        />
      </article>
    </section>
  </main>
</template>

<script>
import { computed } from 'vue';
import { useHead } from '@vueuse/head';

import instruction1 from '../../assets/images/instruction_1.png';
import instruction2 from '../../assets/images/instruction_2.png';
import instruction3 from '../../assets/images/instruction_3.png';
import instruction4 from '../../assets/images/instruction_4.png';

export default {
  name: 'HowToUseAdmin',
  setup() {
    useHead({
      title: computed(() => 'วิธีการใช้งานระบบ - RUNRACE.IN.TH'),
      meta: [
        {
          name: 'description',
          content: 'คู่มือวิธีการใช้งานระบบสำหรับผู้ดูแลระบบ RUNRACE',
        },
      ],
    });
  },
  data() {
    return {
      instructionImages: [instruction1, instruction2, instruction3, instruction4],
      stepTitles: [
        'เข้าสู่ระบบของผู้ดูแล',
        'เข้าสู่หน้าระบบ RUNRACE',
        'Export รายงานผู้สมัคร',
        'รายงานอื่นๆ',
      ],
    };
  },
};
</script>

<style scoped>
.admin-guide {
  padding-bottom: 2rem;
}

.admin-guide__header {
  align-items: flex-end;
  background: linear-gradient(135deg, #087f8c 0%, #1c5d99 100%);
  border-radius: 0.75rem;
  color: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding: 2rem 2.25rem;
}

.admin-guide__eyebrow {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  margin: 0 0 0.4rem;
  opacity: 0.8;
}

.admin-guide h1 {
  font-size: clamp(1.5rem, 3vw, 2.25rem);
  margin: 0;
}

.admin-guide__description {
  margin: 0.6rem 0 0;
  opacity: 0.9;
}

.admin-guide__count {
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 2rem;
  font-size: 0.9rem;
  padding: 0.55rem 1rem;
  white-space: nowrap;
}

.admin-guide__steps {
  display: grid;
  gap: 1.5rem;
}

.admin-guide__step {
  background: #fff;
  border: 1px solid #e6e9ed;
  border-radius: 0.75rem;
  box-shadow: 0 0.25rem 1rem rgba(33, 37, 41, 0.06);
  overflow: hidden;
}

.admin-guide__step-label {
  align-items: center;
  display: flex;
  gap: 0.9rem;
  padding: 1rem 1.25rem;
}

.admin-guide__step-label span {
  align-items: center;
  background: #e8f5f5;
  border-radius: 50%;
  color: #087f8c;
  display: inline-flex;
  flex: 0 0 2.25rem;
  font-size: 0.8rem;
  font-weight: 700;
  height: 2.25rem;
  justify-content: center;
}

.admin-guide h2 {
  color: #273444;
  font-size: 1.05rem;
  margin: 0;
}

.admin-guide__image {
  border-top: 1px solid #e6e9ed;
  display: block;
  height: auto;
  max-width: 100%;
  width: 100%;
}

@media (max-width: 576px) {
  .admin-guide__header {
    align-items: start;
    flex-direction: column;
    gap: 1rem;
    padding: 1.5rem;
  }

  .admin-guide__description {
    font-size: 0.9rem;
  }
}
</style>